import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { capture, captureError } from './lib/posthog';

window.addEventListener('error', (event) => {
  captureError(event.error || new Error(event.message), { source: 'window' });
});
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
  captureError(error, { source: 'unhandledrejection' });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => capture('web_vital', {
  metric: metric.name,
  value: metric.value,
  rating: metric.rating,
}));

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => navigator.serviceWorker.register('/service-worker.js')
    .catch((error) => captureError(error, { source: 'service-worker' })));
}
